/** Picks v2 or v1 of the ClickFunnels Webhook page based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import ClickFunnelsWebhookPage   from './ClickFunnelsWebhookPage';
import ClickFunnelsWebhookPageV2 from './v2/ClickFunnelsWebhookPageV2';

export default function ClickFunnelsWebhookPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? ClickFunnelsWebhookPageV2 : ClickFunnelsWebhookPage;
  return <Component {...props} />;
}
